import React from 'react';
//import css from './css.module.less';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
//import FocusPoint from 'src/components/ImageFocusPointEdit';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import Uploader from 'src/constrains/SingleImageUploader';
import {
  BackgroundStyle,
  backgroundStyle,
  image,
  //imageSetting,
  //backgroundColor,
  primaryColor,
  tabColor,
  textColor,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage-revamp/constant';
import { sectionProps } from 'src/tools/constant';
// import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import { get } from 'lodash';
import ColorPicker from 'src/components/Modules-revamp/ColorPicker';
import { Field, itemWrapperErrorDisplayAdaptor } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { checkBackgroundStyle } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage-revamp/validator';
import { i18nGet } from 'src/tools/tools';
import { getEditableStatus } from '../../SalesChannelEditorAllProductPage-revamp/util';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import { backgroundStyleFields } from '../fields';
const imageN = [backgroundStyle, image];
//const focusN = [...imageN, imageSetting];

const BS = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, isPrimary } = props;

  return (
    <Wrapper id={BackgroundStyle} breakpoint={breakpoint}>
      <BlockTitle
        id={BackgroundStyle}
        title={getI18n('general.hOCTitle.backgroundStyle')}
        breakpoint={breakpoint}
        onReset={() =>
          props.handleOnSectionReset(backgroundStyleFields, breakpoint)
        }
        onCopy={() =>
          props.handleOnSectionCopy(backgroundStyleFields, breakpoint)
        }
        headerErrorDependencies={[imageN]}
        validator={(data) => {
          const i = get(data, imageN);
          return checkBackgroundStyle(i);
        }}
      />
      <Field shouldUpdate>
        {(props, meta, { getFieldValue }) => {
          const is_editable = getEditableStatus(
            getFieldValue,
            BackgroundStyle,
            breakpoint,
          );
          return (
            <Section {...sectionProps}>
              <Field
                name={imageN}
                rules={[
                  {
                    validator: async (rules: any, value: any) => {
                      const res = checkBackgroundStyle(value);

                      const hasError = get(res, 'hasError');
                      const errors = get(res, 'errors');
                      if (hasError) {
                        return Promise.reject(
                          new Error((errors || []).join(',')),
                        );
                        //</ItemWrapper>throw Error((errors || []).join(','));
                      }
                    },
                  },
                ]}>
                {(
                  props,
                  meta,
                  { getFieldValue, setFields, setFieldsValue },
                ) => {
                  const e = itemWrapperErrorDisplayAdaptor(meta);
                  return (
                    <ItemWrapper
                      title={getI18n('general.tools_helper.image')}
                      bottomTitle={`${getI18n(
                        'general.allowedfiletypes',
                      )}: jpeg, gif, png`}
                      size='small'
                      {...e}>
                      <Uploader
                        height={180}
                        {...props}
                        disabled={!is_editable}
                      />
                    </ItemWrapper>
                  );
                }}
              </Field>
              {/* <Field
                shouldUpdate={(p, c) => {
                  return get(p, imageN) !== get(c, imageN);
                }}>
                {(
                  props,
                  meta,
                  { getFieldValue, setFields, setFieldsValue },
                ) => {
                  const image = getFieldValue(imageN);
                  return (
                    <Field name={focusN}>
                      {(props, meta) => {
                        //const value = props.value;
                        const onChange = props.onChange;
                        return (
                          <FocusPoint
                            disabled={!is_editable}
                            image={image}
                            onChange={(image) => {
                              onChange(get(image, 'image.imageSetting'));
                            }}
                          />
                        );
                      }}
                    </Field>
                  );
                }}
              </Field> */}
              {isPrimary && (
                <>
                  <ItemWrapper
                    title={getI18n('salesChannelContent.index.primaryColour')}>
                    <Field name={[backgroundStyle, primaryColor]}>
                      <ColorPicker
                        multi
                        disabled={breakpoint !== EPreviewSize.WIDE}
                      />
                    </Field>
                  </ItemWrapper>
                  <ItemWrapper title={getI18n('general.bodyTextColour')}>
                    <Field name={[backgroundStyle, textColor]}>
                      <ColorPicker
                        multi
                        disabled={breakpoint !== EPreviewSize.WIDE}
                        defaultValue={'rgba(255,255,255,1)'}
                      />
                    </Field>
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n('salesChannelContent.index.tabColour')}>
                    <Field name={[backgroundStyle, tabColor]}>
                      <ColorPicker
                        disabled={breakpoint !== EPreviewSize.WIDE}
                      />
                    </Field>
                  </ItemWrapper>
                </>
              )}
            </Section>
          );
        }}
      </Field>
    </Wrapper>
  );
};
export default BS;
